import { useLocation } from 'react-router-dom';
import {
  inspectionReportPath,
  reportPath,
  sectionOf,
  surveyPath,
} from '../pages/WorkEnvironmentSurveyDetail/surveyRoutes';

/** Links to a survey and its reports in the part of the menu the user is in */
export const useSurveyPaths = () => {
  const section = sectionOf(useLocation().pathname);
  return {
    section,
    survey: (surveyId: number) => surveyPath(section, surveyId),
    report: (surveyId: number) => reportPath(section, surveyId),
    inspectionReport: (surveyId: number) => inspectionReportPath(section, surveyId),
  };
};
